var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "my-resize",
    class: _vm.classes,
    style: _vm.styles
  }, [_vm._t("default"), _vm.helper && _vm.resizing ? _c("div", {
    staticClass: "my-resize__helper",
    style: _vm.helperStyle
  }) : _vm._e(), !_vm.disabled && (!_vm.axis || _vm.axis === "h") ? _c("my-drag", {
    ref: "ctrlH",
    staticClass: "my-resize__ctrl-h",
    attrs: {
      axis: "h",
      origin: _vm.getOrigin
    },
    on: {
      start: _vm.handleStart,
      drag: _vm.handleDragH,
      stop: _vm.handleStop
    }
  }) : _vm._e(), !_vm.disabled && (!_vm.axis || _vm.axis === "v") ? _c("my-drag", {
    ref: "ctrlV",
    staticClass: "my-resize__ctrl-v",
    attrs: {
      axis: "v",
      origin: _vm.getOrigin
    },
    on: {
      start: _vm.handleStart,
      drag: _vm.handleDragV,
      stop: _vm.handleStop
    }
  }) : _vm._e(), !_vm.disabled && !_vm.axis ? _c("my-drag", {
    ref: "ctrl",
    staticClass: "my-resize__ctrl",
    attrs: {
      origin: _vm.getOrigin
    },
    on: {
      start: _vm.handleStart,
      drag: _vm.handleDrag,
      stop: _vm.handleStop
    }
  }, [_vm._t("icon")], 2) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };